// extracted by mini-css-extract-plugin
export default {"container":"NET9jAgwO7DSOice7IdI","leftPart":"Lb3YL8SZToeb7xRWdasx"};